import React from 'react';
import useGetData from './helpers/useGetData';
import Tooltip from '@mui/material/Tooltip';
import { BsBoxSeamFill } from 'react-icons/bs';
import {
  BoxRow,
  BoxContainer,
  ShelfLabel,
  Shelf,
  InventoryGrid,
  Label,
  Border,
  ShelfEndBorder,
  ShelfEndInnerBorder,
  LeftVerticalLine,
  RightVerticalLine,
  CompartmentName,
} from './store.styled';
import { Loader } from '../../../components/common/Loader';

const View = () => {
  const { gridData, isLoading } = useGetData();

  const renderCompartments = (compartments: any) => {
    if (!compartments || compartments.length === 0) {
      return null;
    }
    return compartments.map((compartment: any, index: number) => (
      <React.Fragment key={index}>
        <BoxRow>
          <CompartmentName>{compartment.name}</CompartmentName>
          {compartment?.ri_part_id &&
            Object.keys(compartment.ri_part_id || {}).map((key, i) => (
              <Tooltip
                title={compartment.ri_part_id[key]?.part_name || 'Unknown'}
                key={i}
              >
                <BoxContainer>
                  <BsBoxSeamFill
                    style={{ color: '#dbb279', fontSize: '24px' }}
                  />
                  <Label>{compartment.ri_part_id[key]?.qty}</Label>
                </BoxContainer>
              </Tooltip>
            ))}
        </BoxRow>
        {index < compartments.length - 1 && <Border />}
      </React.Fragment>
    ));
  };

  const renderRacks = () => {
    return gridData.map((rack: any) => (
      <div key={rack._id}>
        <ShelfLabel>{rack.name}</ShelfLabel>
        <Border />
        <Shelf>
          {renderCompartments(rack.compartments)}
          <ShelfEndBorder>
            <ShelfEndInnerBorder />
            <RightVerticalLine />
            <LeftVerticalLine />
          </ShelfEndBorder>
        </Shelf>
      </div>
    ));
  };

  return (
    <>
      <Loader loader={isLoading} />
      <InventoryGrid>{renderRacks()}</InventoryGrid>
    </>
  );
};

export default View;
